var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "iframestyleset",
    },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            {
              staticClass: "suitability_home left_text_align",
              staticStyle: { cursor: "pointer", "margin-left": "35px" },
              attrs: { span: 14 },
              nativeOn: {
                click: function ($event) {
                  return _vm.backHome.apply(null, arguments)
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-s-home" }),
              _vm._v("返回主页菜单"),
              _c("div", { staticClass: "imgs_logo" }),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-col",
            {
              staticClass: "suitability_home right_text_align",
              staticStyle: { cursor: "pointer" },
              attrs: { span: 9 },
              nativeOn: {
                click: function ($event) {
                  return _vm.logoutAccount.apply(null, arguments)
                },
              },
            },
            [
              _c("span", { staticClass: "font_title_email" }, [
                _vm._v(_vm._s(_vm.account)),
              ]),
              _c("span", { staticStyle: { "margin-right": "44px" } }, [
                _vm._v("[退出]"),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("iframe", {
        attrs: {
          name: "iframeMap",
          id: "iframeMapViewComponent",
          width: "100%",
          height: "100%",
          src: "PortfolioAnalyst.html",
          frameborder: "0",
          scrolling: "yes",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }